export default "__VITE_ASSET__BBEPs6jD__"